import { render, staticRenderFns } from "./AfasField.vue?vue&type=template&id=7c91c70c&scoped=true"
import script from "./AfasField.vue?vue&type=script&lang=ts"
export * from "./AfasField.vue?vue&type=script&lang=ts"
import style0 from "./AfasField.vue?vue&type=style&index=0&id=7c91c70c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c91c70c",
  null
  
)

export default component.exports